module.exports = __webpack_public_path__ + "img/input_gene_phone.d8249050.png";